import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import styled from "styled-components";

import {
  BackgroundImageContainer,
  SlideContainer as Container,
  Paragraph,
  Title,
} from "./OurCommitment.styles";
import sixMillionGreen from "../../assets/images/6,000,000.png";

const SlideContainer = styled(Container)`
  
`;

const OurCommitmentSlide2 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <SlideContainer style={{ padding: "120px 20px 0px 20px"}}>
      <BackgroundImageContainer>
        <BigNumber />
      </BackgroundImageContainer>
      <GarbageAnnounceContainer>
        <Title style={{ marginTop: 0}} theme={theme}>
          {t("Mattresses End Up In Canadian Landfills Every Year")}
        </Title>
        <Paragraph theme={theme}>
          {t(
            "This number must be lowered. The average sleeper buys a new mattress every 7 - 10 years, and this is what the industry wants. So we asked ourselves: what if a mattress lasted longer? We know certain components fail faster than others, rendering the entire mattress useless. This ultimately lead us to the evrbed modular mattress system."
          )}
        </Paragraph>
        <Paragraph theme={theme}>
          {t(
            "By developing a mattress with replaceable components, you change only what you need to, when you need to. This means the evrbed can last a lifetime - we meant it when we said \"never buy another bed\"!"
          )}
        </Paragraph>
      </GarbageAnnounceContainer>
    </SlideContainer>
  );
};

const BigNumber = styled.img.attrs({
  src: sixMillionGreen,
})`
  width: 100%;
`;

const GarbageAnnounceContainer = styled.div`
  width: 100%;

`;

export default OurCommitmentSlide2;
